import { Model } from "pinia-orm";
import { QuestionnaireSessionQuestion, Scenario, UserSession } from "@/models";

export default class QuestionnaireSession extends Model {
  static entity = "questionnaireSessions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.string(""),
      createdBy: this.string(""),
      modifiedBy: this.string(""),
      startDate: this.string(""),
      finishedDate: this.string(""),
      isFinished: this.boolean(false),
      // TODO - NL - 12/06/2023 - What is this? QuestionnaireSession doesn't have relation to Question model
      questions: this.attr([]),
      totalScore: this.number(0),
      totalNotation: this.number(0),

      // Foreign keys
      scenarioUuid: this.string(""),
      scenarioData: this.belongsTo(Scenario, "scenarioUuid"),
      userSessionUuid: this.string(""),
      userSessionData: this.belongsTo(UserSession, "userSessionUuid"),
      questionnaireSessionQuestionsList: this.hasMany(
        QuestionnaireSessionQuestion,
        "questionnaireSession",
      ),
    };
  }
}
